const AppFonts = {
    robotoBold: 'Roboto-Bold',
    robototMedium: 'Roboto-Medium',
    robotoItalic: 'Roboto-Italic',
    robotoRegular: 'Roboto-Regular',
    robotoBlack: 'Roboto-Black'

}
export default AppFonts;